import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=7525f059&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=ts"
export * from "./reset-password.vue?vue&type=script&lang=ts"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=7525f059&lang=scss"
import style1 from "./reset-password.vue?vue&type=style&index=1&id=7525f059&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7525f059",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7525f059')) {
      api.createRecord('7525f059', component.options)
    } else {
      api.reload('7525f059', component.options)
    }
    module.hot.accept("./reset-password.vue?vue&type=template&id=7525f059&scoped=true", function () {
      api.rerender('7525f059', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/reset-password.vue"
export default component.exports